import React, { Component } from 'react';
import { Form } from '@ant-design/compatible';
import { Button, Select } from 'antd';
import dayjs from 'dayjs';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import * as driverActions from '../../../core/driver/driverActions';
import * as assetActions from '../../../core/asset/assetActions';
import * as reportActions from '../../../core/report/reportActions';
import DateRangePicker from '../../../components/DateRangePicker';
import { Erase } from '@carbon/icons-react';

class assetJourneyHistoryFilterForm extends Component {
    constructor (props) {
        super(props);
        let currentAssetFilters = null;
        if (props?.assetViewJourneyFilters?.length) {
            const matches = props.assetViewJourneyFilters.filter(f => parseInt(f.assetId) === parseInt(props.assetId));
            if (matches?.length) {
                currentAssetFilters = matches[0]?.filters;
            }
        }
        this.state = { currentAssetFilters };
    }

    componentDidUpdate(prevProps) {
        const { assetViewJourneyFilters, assetId } = this.props;
        
        if (prevProps.assetViewJourneyFilters !== assetViewJourneyFilters) {
            let currentAssetFilters = null;
            if (assetViewJourneyFilters?.length) {
                const matches = assetViewJourneyFilters.filter(f => parseInt(f.assetId) === parseInt(assetId));
                if (matches?.length) {
                    currentAssetFilters = matches[0]?.filters;
                }
            }
            this.setState({ currentAssetFilters });
        }
    }

    submitForm = (e) => {
        const { onSubmit, form } = this.props;

        e.preventDefault();
        form.validateFields((err, values) => {
            if (!err) {
                onSubmit(values);
            }
        });
    };

    render() {
        const { form, telematicsRetentionDays, driverList } = this.props;
        const { currentAssetFilters } = this.state;
        
        const { getFieldDecorator, getFieldValue } = form;

        return (
            <Form 
                onSubmit={this.submitForm} 
                layout="vertical"
            >
                <DateRangePicker
                    getFieldDecorator={getFieldDecorator}
                    getFieldValue={getFieldValue}
                    minDate={dayjs().subtract(telematicsRetentionDays, 'days')}
                    dateFromInitialValue={dayjs(currentAssetFilters?.date_from) || dayjs()}
                    dateToInitialValue={dayjs(currentAssetFilters?.date_to) || dayjs()}
                    dataTestId='asset-details-journey-filter_date-range-picker'
                />
                <Form.Item label="Journey events">
                    {getFieldDecorator('journey_event', { initialValue: currentAssetFilters?.journey_event || 'all' })(
                        <Select placeholder="Select Journey events">
                            <Select.Option value="all">All</Select.Option>
                            <Select.Option value="1">Yes</Select.Option>
                            <Select.Option value="0">No</Select.Option>
                        </Select>
                    )}
                </Form.Item>
                <Form.Item label="Driver">
                    {getFieldDecorator('driver', { initialValue: currentAssetFilters?.driver || null })(
                        <Select
                            mode="multiple"
                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            placeholder="Select driver"
                            showSearch
                            allowClear={<Erase size={12} />}
                            data-testid='asset-details-journey-filter_driver-select'
                        >
                            {driverList.map((dl) => <Select.Option key={dl.id} value={dl.id}>{dl.name}</Select.Option>)}
                        </Select>,
                    )}
                </Form.Item>
                <Form.Item label="Authorised">
                    {getFieldDecorator('is_authorised', { initialValue: currentAssetFilters?.is_authorised || 'all' })(
                        <Select
                            placeholder="Select authorised journeys"
                        >
                            <Select.Option value="all">All</Select.Option>
                            <Select.Option value="1">Yes</Select.Option>
                            <Select.Option value="0">No</Select.Option>
                        </Select>,
                    )}
                </Form.Item>
                <div className="mt-2 mb-1 text-center">
                    <Button
                        htmlType="submit"
                        type="primary"
                        data-testid='asset-details-journey-filter_filter-btn'
                    >
                        Filter
                    </Button>
                </div>
            </Form>
        );
    }
}

assetJourneyHistoryFilterForm.propTypes = {
    driverList: PropTypes.array.isRequired,
    assetJourneyFilters: PropTypes.object.isRequired,
    assetId: PropTypes.number,
    actions: PropTypes.object.isRequired,
};

const assetJourneyHistoryFilter = Form.create({ name: 'event_filter_form' })(assetJourneyHistoryFilterForm);

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        driverList: state.driver.driverList,
        assetJourneyFilters: state.asset.assetJourneyFilters,
        telematicsRetentionDays: state.user.userCompany.telematics_retention_days,
        assetViewJourneyFilters: state.asset.assetViewJourneyFilters,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...driverActions,
            ...assetActions,
            ...reportActions,
        }, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(assetJourneyHistoryFilter);
